import React from 'react'
import classNames from 'classnames'
import TriangleArrowRight from '@/atoms/Icons/TriangleArrowRight'
import { TitleLG } from '@/atoms/Text'
import { Tab } from './Details'

interface Props extends Tab {
  idx: number
  itemsRef: { current: (HTMLElement | null)[] }
}

const ComponentWrap: React.FC<Props> = ({ id, idx, Component, title, itemsRef }) => {
  return (
    <div
      id={id}
      ref={(el) => (itemsRef.current[idx] = el)}
      className={classNames(
        'bg-white flex flex-col justify-center mb-6 px-4 py-8 relative md:px-6 md:rounded-2xl 2lg:mx-0',
        // only apply style if it's the first section, and it's an overview section
        {
          'first:bg-transparent first:mb-16 first:py-0 md:first:px-0': id?.includes('sectionOverview'),
        },
      )}
    >
      {/* Hidden element so scrollIntoView shows top of section below sticky headers */}
      <div id={`${id}-anchor`} className="absolute -top-32 opacity-0" aria-hidden="true" />
      {idx > 0 && title && (
        <>
          <TriangleArrowRight className="absolute left-0 top-8" />
          <TitleLG weight="bold" className="mb-6">
            {title}
          </TitleLG>
        </>
      )}
      <Component />
    </div>
  )
}

export default ComponentWrap
